import { red } from '@material-ui/core/colors';
import { createTheme } from '@material-ui/core/styles';

export const theme = createTheme({
  palette: {
    primary: {
      main: '#2ca85e',
      contrastText: '#fff',
    },
    secondary: {
      main: '#1a2d4f',
      dark: '#121e34',
    },
    error: {
      main: red.A400,
    },
    background: {
      default: '#fff',
    },
    text: {
      primary: '#5d6676',
    },
  },

  typography: {
    button: {
      textTransform: 'none',
    },
    fontFamily: ['DM Sans', 'sans-serif'].join(','),
    fontSize: 16,
  },
});

theme.typography.subtitle1 = {
  ...theme.typography.subtitle1,
  fontSize: '1.3rem',
};

theme.typography.h1 = {
  ...theme.typography.h1,
  fontSize: '3.5rem',
  lineHeight: '125%',
  [theme.breakpoints.down('md')]: {
    fontSize: '2.5rem',
  },
};

theme.typography.h2 = {
  ...theme.typography.h2,
  fontSize: '2.8rem',
  lineHeight: '125%',
  [theme.breakpoints.down('md')]: {
    fontSize: '2rem',
  },
};

theme.typography.h3 = {
  ...theme.typography.h3,
  fontSize: '2.4rem',
  lineHeight: '125%',
  [theme.breakpoints.down('md')]: {
    fontSize: '1.7rem',
  },
};

theme.typography.h4 = {
  ...theme.typography.h4,
  fontSize: '2rem',
  lineHeight: '125%',
  [theme.breakpoints.down('md')]: {
    fontSize: '1.5rem',
  },
};

theme.typography.h5 = {
  ...theme.typography.h5,
  fontSize: '1.6rem',
  lineHeight: '125%',
  [theme.breakpoints.down('md')]: {
    fontSize: '1.3rem',
  },
};

theme.typography.h6 = {
  ...theme.typography.h6,
  fontSize: '1.3rem',
  lineHeight: '125%',
  [theme.breakpoints.down('md')]: {
    fontSize: '1.1rem',
  },
};

theme.typography.overline = {
  ...theme.typography.overline,
  letterSpacing: '0.2em',
};
